import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** ファイルサイズを「N KB」表記に整形する。
 *  四捨五入だが、空 (0 bytes) でない限り最低 "1KB" にする
 *  ── 実体ありのファイルを「0KB（＝空っぽ）」と誤読させないため。 */
export function formatSizeKB(bytes: number | null | undefined): string {
  if (!bytes || bytes <= 0) return "0KB"
  return `${Math.max(1, Math.round(bytes / 1024))}KB`
}
